import Views from './game-ui/views/Views'
import MainView from './game-ui/views/main/MainView'
import GameView from './game-ui/views/game/GameView'
import { useEffect } from "react";
import * as Sentry from "@sentry/react"
import { isProduction } from './Utils';

if (isProduction()) {
  console.log = console.error = console.warn = console.info = () => null
}

type AppProps = {
  roomId: string;
  defaultView: any;
  tournament?: {
    id: string,
    start: number,
    finish: number,
    rank: number,
    score: number
  };
}

function App({ roomId, defaultView, tournament = {} }: AppProps) {
  const views: any = {
    main: MainView,
    game: GameView,
  }

  useEffect(() => {
    const body = document.querySelector('body')
    const uid = window.firebaseUid || ''
    const settings = JSON.parse(window.localStorage.getItem('settings.' + uid + '.game') || '{}')

    if (settings.switchDarkMode) {
      body.classList.add('theme--dark')
    } else {
      body.classList.remove('theme--dark')
    }
  }, []);
  return (
    <div className="App">
      <Views
        views={views}
        default={views[defaultView]}
        roomId={roomId}
        tournament={tournament}
      />
    </div>
  )
}

export default Sentry.withProfiler(App);
